<template>
	<MainLayout>
		<div class="container">
			<div class="box">
				<b-row>
					<b-col>
						<h2 class="inline-heading">Reservaciones</h2>
						<!-- <b-button
							v-if="pendingNotifications > 0"
							size="sm"
							variant="info"
							class="inline-button mr-2"
							@click="launchNotifications(true)"
							>Notificaciones
							<b-badge pill variant="light">{{
								pendingNotifications
							}}</b-badge></b-button
						> -->
					</b-col>
					<b-col class="text-right">
					<b-button
							class="mr-2"
							variant="success"
							@click="newFormQuote"
							v-if="$hasPermission('reservation.quote')"
							>Cotizar</b-button
						>
						<b-button
							v-if="$hasPermission('reservation.booking.add')"
							class="mr-2"
							variant="primary"
							@click="newForm"
							>Nueva Reserva</b-button
						>

						<b-button
							variant="info"
							v-if="$hasPermission('reservation.import')"
							class="float-right mr-2"
							@click="showImportModal"
							>Importar XLS BOOKINGS</b-button
						>
					</b-col>
				</b-row>
				<hr />
				<Filters
					id="reservations-index-filters"
					:filters.sync="filters"
					@search="
						() =>
							$root.$emit(
								'bv::refresh::table',
								'reservations-index-list'
							)
					"
				/>

				<b-form-group class="text-right mt-2">
					<b-overlay  :show="exportLoading" class="d-inline-block" rounded="sm">
						<b-dropdown
							right
							text="Exportar XLS"
							class="mr-2"
							v-if="$hasPermission('reservation.export')"
							variant="warning"
						>
							<b-dropdown-item @click="() => exportXLS(false)"
								>Sin costos</b-dropdown-item
							>
							<b-dropdown-item @click="() => exportXLS(true)"
								>Con costos</b-dropdown-item
							>
							<b-dropdown-item @click="() => exportXLS(false, true)"
								>Con datos de vuelos</b-dropdown-item
							>
						</b-dropdown>
					</b-overlay>
				</b-form-group>


				<hr />
				<b-row no-gutters>
					<b-col>
						<b-badge
							v-for="(aux, i) in $root.auxVars
								.transportServiceStatusOpts"
							:key="i"
							:variant="aux.class"
							class="mr-2"
							size=""
						>
							{{ aux.text }}
						</b-badge>
					</b-col>
				</b-row>
				<b-row class="my-3">
					<b-form-group v-if="showSelectAll" class="col-md-9">
						<b-button
							type="submit"
							variant="warning"
							class="mr-2"
							@click="showAssignSupplierModal"
						>
							<span>Asignar proveedores</span>
						</b-button>
						<b-button
							type="submit"
							variant="warning"
							class="mr-2"
							@click="showAssignStatusModal"
						>
							<span>Asignar estado</span>
						</b-button>
						<b-button
							type="submit"
							variant="warning"
							class="mr-2"
							@click="showAssignSupplierConfirmationModal"
						>
							<span>Asignar confirmación de proveedor</span>
						</b-button>
						<b-button
							type="submit"
							variant="warning"
							class="mr-2"
							@click="showCalculatePickupModal"
						>
							<span>Calculo de pickup</span>
						</b-button>


						<b-dropdown
							right
							text="Mas opciones"

							variant="warning"
						>
							<b-dropdown-item @click="showAssignCategoryModal"
								>Asignar categoria</b-dropdown-item
							>
							<b-dropdown-item @click="showAssignTagsModal"
								>Asignar Etiquetas</b-dropdown-item
							>
						</b-dropdown>
					</b-form-group>
					<b-form-group
						v-if="!showSelectAll"
						class="col-md-9"
					></b-form-group>
					<b-form-group class="col-md-3 text-right mt-2" v-if="$hasPermission('reservation.booking.massiveOption')">
						<b-button
							type="submit"
							variant="primary"
							class="mr-2"
							@click="toggleMassiveAssign"
						>
							<span v-if="!showSelectAll"
								>Habilitar operaciones masivas</span
							>
							<span v-else>Deshabilitar operaciones masivas</span>
						</b-button>
					</b-form-group>
				</b-row>
				<AjaxTable
					permission-show="reservation.show"
					id="reservations-index-list"
					ref="childtable"
					stacked="lg"
					:show-select-all="showSelectAll"
					:selected-items.sync="items"
					:filters="filtersClean"
					:columns="filteredColumns"
					:items-filter="itemsFilter"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="transport-services"
					responsive
					:items.sync="itemsTable"
				>
					<template #cell(reservationId)="row">
						<span v-if="row.item.revisedByUser != null" class="text-success" v-b-tooltip.hover :title="'Servicio validado por ' + row.item.revisedByUser"><md-icon icon="verified" /></span>
						{{row.item.serviceNumber}}
						<div v-if="!$root.isEmpty(row.item.tags)">
							<template v-for="(tag,index) in row.item.tags">
								<b-badge variant="primary" class="mr-1" :key="index" v-if="!isFlightTag(tag.id)">{{tag.text}}</b-badge>
								<FlightInfoPopover
									v-else
									:key="'flight-'+index"
									:tag="tag"
									:item="row.item"
									:index="index"
									:autoLoad="[11, 13].includes(tag.id)"
									:show-dot="false"
								/>
							</template>

						</div>
					</template>
					<template #cell(actions)="row">
						<div class="d-flex">
							<b-button
								@click="copyRes(row.item.reservationId)"
								type="button"
								size="sm"
								class="mr-1"
								variant="dark"
								v-if="$hasPermission('reservation.copy')"
							>
								<md-icon icon="library_add" />
							</b-button>

							<b-button
								@click="
									event =>
										viewForm(
											row.item,
											row.index,
											event,
											row.item
										)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="visibility"></md-icon>
							</b-button>
						</div>
					</template>
					<template #cell(clientName)="row">
						{{ row.item.reservation.client.firstName }}
						{{ row.item.reservation.client.lastName }}
					</template>
					<template #cell(clientPhone)="row">
						{{ row.item.reservation.client.phoneNumber }}
					</template>
					<template #cell(clientEmail)="row">
						{{ row.item.reservation.client.email }}
					</template>
					<template #cell(pickup)="row">
						<b-button
							size="sm"
							v-if="
								row.item.pickup.latitude === null ||
									row.item.pickup.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.pickup.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.pickup.name }}
					</template>
					<template #cell(dropoff)="row">
						<b-button
							size="sm"
							v-if="
								row.item.dropoff.latitude === null ||
									row.item.dropoff.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.dropoff.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.dropoff.name }}
					</template>
					<template #cell(passengers)="row">
						{{
							row.item.reservation.adults +
								row.item.reservation.children +
								row.item.reservation.infants
						}}
					</template>
					<template #cell(serviceType)="row">
						{{ row.item.serviceType.name }}
					</template>
					<template #cell(serviceTypeCategory)="row">
						{{ row.item.serviceTypeCategory.name }}
					</template>
					<template #cell(contactStatus)="row">
						{{ contactStatusLabels[row.item.contactStatus] }}
					</template>
					<template #cell(salesChannel)="row">
						<span style="white-space: nowrap;">
							<b-badge
								v-if="row.item.sourceLabel"
								variant="info"
								class="ml-1">
								{{ row.item.sourceLabel }}
							</b-badge>
							{{ row.item.salesChannel.name }}
							<br>
							<b-badge
								v-if="row.item.genius"
								variant="info"
								class="ml-1">
								{{ row.item.genius.level }}
							</b-badge>
						</span>
					</template>
					<template #cell(pickupDatetime)="row">
						{{ row.item.pickupDatetime }}
						<div
							v-if="row.item.pickupDatetimeAutoUpdatedAt"
							v-b-tooltip.hover
							title="Actualizado por el sistema de forma automática debido al monitoreo de vuelos"
							class="text-muted"
							style="font-size: 0.75em; cursor: help;"
						>
							Actualizado: {{ formatDateTime(row.item.pickupDatetimeAutoUpdatedAt) }}
						</div>
					</template>
					<template #cell(checkinStatus)="row">
						<b-badge :variant="checkinStatusVars[row.item.checkinStatus].class">
							{{ checkinStatusVars[row.item.checkinStatus].text }}
						</b-badge>
					</template>
					<template #cell(paymentStatus)="row">
						<b-badge :variant="paymentStatusVars[row.item.paymentStatus].class">
							{{ paymentStatusVars[row.item.paymentStatus].text }}
						</b-badge>
					</template>
					<template #cell(flightDatetime)="row">
						<span
							:class="
								row.item.flightValidationStatus !== 'none'
									? 'text-success text-center'
									: 'text-danger text-center'
							"
						>
							<md-icon
								:icon="
									row.item.flightValidationStatus !== 'none'
										? 'check_circle'
										: 'info'
								"
							/>
						</span>
						{{ row.item.flightDatetime }} /
						<template v-if="row.item.flightValidationStatus !== 'none'">
							<FlightInfoPopover
								:tag="{ text: row.item.flightNumber }"
								:item="row.item"
								:index="row.index"
							/>
						</template>
						<template v-else>
							{{ row.item.flightNumber }}
						</template>
					</template>
					<template #cell(supplier)="row">
						<span
							:class="
								iconSupplierConfirmation(
									row.item.supplierConfirmation
								).class
							"
						>
							<md-icon
								:icon="
									iconSupplierConfirmation(
										row.item.supplierConfirmation
									).icon
								"
							/>
						</span>
						{{ row.item.supplier.name }}
						<template v-if="row.item.lastRejectedSupplierName">
							<br />Rechazado por:
							{{ row.item.lastRejectedSupplierName }}
						</template>
					</template>
					<template #cell(serviceTypeSupplier)="row">
						{{ row.item.supplierServiceType.name }}
					</template>
					<template #cell(additionalService)="row">
						{{additionalServiceString(row.item)}}
					</template>
					<template #cell(status)="row">
						{{ statusLabels[row.item.status] }}
					</template>
					<template #cell(netPriceTotal)="row">
						<template v-if="$hasPermission('reservation.cost.show')">
							{{ row.item.netPriceTotal }}{{ row.item.netCurrency }}
						</template>
						<template v-else>
							N/A
						</template>
					</template>
					<template #cell(supplierPriceTotal)="row">
						<template v-if="$hasPermission('reservation.cost.show')">
							{{ row.item.supplierPriceTotal }}{{ row.item.supplierCurrency }}
						</template>
						<template v-else>
							N/A
						</template>
					</template>

					<template #cell(supplierAssignedAt)="row">
						{{row.item.supplierAssignedAt }}
						<small>{{row.item.timeAgoAssigned}}</small>
					</template>
					<template #cell(notificationsLogs)="row">
						<div v-if="row.item.notificationsLogs">
							<b-badge v-for=" (template,_i) in row.item.notificationsLogs" variant="success" :key="_i">{{ template }}</b-badge>
						</div>
					</template>
				</AjaxTable>

			</div>
		</div>
		<FormReservation
			:tsSelectedId="selected.tsSelectedId"
			:model-id="selected.modalModelId"
			:copy-from-id="selected.copyResId"
			:formTypeWork="formTypeWork"
			@changeId="($event)=>{selected.modalModelId = $event; formTypeWork='viewForm'}"
			@onCopyRes="copyCurrentRes"
			v-model="form.add"
		/>

		<FormQuoteV2
			v-model="quote.showForm"
			@closeModal="()=>{SET_UPDATE_QUOTE_PROPS({showForm:false})}"
			@changeFormTypeWork="changeFormTypeWork"
			@openReservationForm="form.add = true"
			:formTypeWork="formTypeWork"
		/>
		<ImportModal />
		<AssignSuplierModal ref="assigned-supplier" :selected.sync="itemsObject" />
		<AssignCategoryModal :selected.sync="items" />
		<AssignTagsModal :selected.sync="items" />
		<AssignStatusModal :selected.sync="items" />
		<AssignSupplierConfirmationModal :selected.sync="items" />
		<CalculateMassivePickupsModal
			:selected.sync="items"
			:res-view="viewForm"
		/>
		<PlaceSingle
			ref="placeSingle"
			:success-callback="updatePlaceSuccessCallback"
		/>
		<vue-snotify />
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import AjaxTable from "../../helpers/AjaxTable";
import ImportModal from "./ImportModal";
import AssignSuplierModal from "./AssignSuppliers/AssignSuplierModal";
import AssignStatusModal from "./AssignStatusModal";
import Filters from "./Filters";
import PlaceSingle from "@/components/sections/places/Single";
import AssignSupplierConfirmationModal from "./AssignSupplierConfirmationModal";
import AssignCategoryModal from "./AssignCategoryModal";
import AssignTagsModal from "./AssignTagsModal.vue";
import CalculateMassivePickupsModal from "./CalculateMassivePickupsModal";
import api from "../../../api.js";
import moment from "moment";
import {mapMutations,mapState} from 'vuex'

//New version form
import FormReservation from "../reservation/formReservation/index";
import FormQuoteV2 from "./quoteV2/FormQuote";
import FlightInfoPopover from "./FlightInfoPopover.vue";

export default {
	components: {
		FormReservation,
		MainLayout,
		ImportModal,
		AssignSuplierModal,
		AssignStatusModal,
		AssignCategoryModal,
		AssignTagsModal,
		AssignSupplierConfirmationModal,
		AjaxTable,
		CalculateMassivePickupsModal,
		Filters,
		PlaceSingle,
		FormQuoteV2,
		FlightInfoPopover
	},
	data() {
		let defaultFilters = {
			id: "",
			clientFullName: "",
			clientPhone: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			creationUser: [],
			airport: [],
			serviceType: [],
			serviceTypeCategory: [],
			pickupStartDate: "",
			pickupStartTime: "",
			pickupEndDate: "",
			pickupEndTime: "",
			creationStartDate: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			asignationStartDate: "",
			asignationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			onlyWithAdditionalServices: false,
			oneway: false,
			zones:[],
			invalidSupplierServiceType:false,
			tags:[],
			netPriceTotalStart:null,
			netPriceTotalEnd:null,
			supplierPriceTotalStart:null,
			supplierPriceTotalEnd:null,
			fightNumber:"",
			withSupplierPromo: false,
			geniusBooking: null,
			paxMin: null,
			paxMax: null
		};
		return {
			intervalVar:null,
			itemsTable:[],
			formTypeWork:'newForm',//viewForm -newForm- newFormCopy - newFormLocationReferences
			form: {
				add: false,
			},
			selected: {
				modalModelId: -1,
				tsSelectedId: -1,
				copyResId: -1
			},
			itemsObject: [],
			items: [],
			pendingNotifications: 0,
			exportLoading: false,
			showSelectAll: false,

			sortBy: "reservationId",
			sortDesc: true,
			filters: { ...defaultFilters },
			modelColumns: [
				{
					key: "reservationId",
					label: "Num. Servicio",
					sortable: true,
					disabled: true,
					formatter(value, key, item){
						return item.serviceNumber
					}
				},
				{ key: "notificationsLogs", label: "Notificaciones" },
				{ key: "clientName", label: "Cliente" },
				{ key: "clientPhone", label: "Cliente Tel" },
				{ key: "clientEmail", label: "Cliente Email" },
				{ key: "pickup", label: "Pickup" },
				{ key: "dropoff", label: "Dropoff" },
				{ key: "passengers", label: "Pasajeros" },
				{
					key: "pickupDatetime",
					label: "Fecha Pickup",
					sortable: true
				},
				{ key: "flightDatetime", label: "Fecha Vuelo" },
				{ key: "serviceType", label: "Tipo servicio" },
				{ key: "serviceTypeCategory", label: "Categoria del servicio" },
				{ key: "salesChannel", label: "Canal de venta" },
				{ key: "salesChannelReference", label: "Referencia" },
				{ key: "supplier", label: "Proveedor" },
				{ key: "serviceTypeSupplier", label: "T. servicio proveedor" },
				{ key: "supplierAssignedAt", label: "Fecha asignación" },
				{ key: "trip", label: "Viaje" },
				{ key: "contactStatus", label: "Confirmado" },
				{ key: "checkinStatus", label: "Webcheckin"},
				{ key: "trackingStatus", label: "Tracking status"},
				{ key: "reasonState.label", label: "Razón de estado"},
				{ key: "additionalService", label: "Servicios Ad." },
				{ key: "netPriceTotal", label: "Costo venta", sortable: true },
				{ key: "supplierPriceTotal", label: "Costo proveedor", sortable: true },
				{ key: "paymentStatus", label: "Pago" },
				{ key: "actions", label: "Acciones", disabled: true }
			],
			//modales
			formQuoteModal:false,
			// Flight info popover
			flightTagIds: [13, 16, 11],
		};
	},
	computed: {
		...mapState("reservation", ["viewModel", "quote"]),
		filteredColumns() {
			let aux = [];
			if (this.showSelectAll) {
				aux.push({ key: "selected", label: "" });
			}
			aux = aux.concat(this.modelColumns);
			return aux;
		},
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				clientPhone: this.filters.clientPhone,
				destination: this.filters.destination.map(aux => aux.value),
				airport: this.filters.airport.map(aux => aux.value),
				salesChannel: this.filters.salesChannel.map(aux => aux.value),
				supplier: this.filters.supplier.map(aux => aux.value),
				creationUser: this.filters.creationUser.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				serviceTypeCategory: this.filters.serviceTypeCategory.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				pickupStartTime: this.filters.pickupStartTime,
				pickupEndTime: this.filters.pickupEndTime,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				asignationStartDate: this.filters.asignationStartDate,
				asignationEndDate: this.filters.asignationEndDate,
				trip: this.filters.trip,
				contactStatus: this.filters.contactStatus,
				revisedStatus: this.filters.revisedStatus,
				status: this.filters.status.map(aux => aux.value),
				statusCheckin: this.filters.statusCheckin.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				supplierReference: this.filters.supplierReference,
				containsEmail: this.filters.containsEmail,
				clientEdited: this.filters.clientEdited,
				clientConfirmed: this.filters.clientConfirmed,
				pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
				fromPointOfSale: this.filters.fromPointOfSale,
				supplierConfirmation: this.filters.supplierConfirmation,
				placesWithoutCoordinates: this.filters.placesWithoutCoordinates,
				supplierPriceTotalEmpty: this.filters.supplierPriceTotalEmpty,
				onlyWithAdditionalServices: this.filters.onlyWithAdditionalServices,
				oneway: this.filters.oneway,
				zones:this.filters.zones.map(aux => aux.value),
				invalidSupplierServiceType:this.filters.invalidSupplierServiceType,
				withSalesChannelPromo:this.filters.withSalesChannelPromo,
				withSupplierPromo: this.filters.withSupplierPromo,
				withChat: this.filters.withChat,
				tags:this.filters.tags.map(aux => aux.value),
				netPriceTotalStart: this.filters.netPriceTotalStart,
				netPriceTotalEnd: this.filters.netPriceTotalEnd,
				supplierPriceTotalStart: this.filters.supplierPriceTotalStart,
				supplierPriceTotalEnd: this.filters.supplierPriceTotalEnd,
				flightNumber:this.filters.fightNumber,
				geniusBooking: this.filters.geniusBooking,
				paxMin: this.filters.paxMin,
				paxMax: this.filters.paxMax
			};
		},
		contactStatusLabels() {
			let vars = this.$root.auxVars.transportServiceContactStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		checkinStatusVars() {
			let vars = this.$root.auxVars.webCheckingStatus;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = {...vars[i]};
			}
			return opts;
		},
		paymentStatusVars() {
			let vars = this.$root.auxVars.transportServicePaymentStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = {...vars[i]};
			}
			return opts;
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		serviceStatusVariants() {
			let aux = {};
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class;
			});
			return aux;
		}
	},
	methods: {
		...mapMutations("reservation", ["SET_RESET_MODEL","SET_UPDATE_QUOTE_PROPS","DEL_TRANSPORT_SERVICE"]),
		openPlace(id) {
			this.$refs.placeSingle.loadModel(id);
		},
		updatePlaceSuccessCallback() {
			this.$root.$emit(
				"bv::refresh::table",
				"reservations-index-list"
			);
		},
		copyCurrentRes() {
			this.selected.copyResId = this.selected.modalModelId;
			this.selected.modalModelId = -1;
			this.form.add = true;
		},
		itemsFilter(items) {
			return items.map(item => ({
				...item,
				pickupDatetime: moment(item.pickupDatetime).format(
					"DD/MM/YYYY HH:mm"
				),
				flightDatetime: item.flightDatetime
					? moment(item.flightDatetime).format("DD/MM/YYYY HH:mm")
					: "",
				_rowVariant: this.serviceStatusVariants[item.status],
				timeAgoAssigned: this.getTimeAgo(item.supplierAssignedAt)
			}));
		},
		showImportModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-import-view",
				event.target
			);
		},
		showAssignSupplierModal() {
			const itemsObject = this.items.map(id => {
				return this.$refs.childtable.data.find(item => item.id === id)
			})
			//Se elimina los valores null
			.filter(n => n)

			this.itemsObject = JSON.parse(JSON.stringify(itemsObject))
			setTimeout(() => {
				this.$root.$emit(
					"bv::show::modal",
					"modal-assign-supplier-view"
				);
			}, 100);
		},
		showAssignStatusModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-status-view",
				event.target
			);
		},
		showAssignCategoryModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-category-view",
				event.target
			);
		},
		showAssignTagsModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-tags-view",
				event.target
			);
		},
		showAssignSupplierConfirmationModal() {
			this.$root.$emit(
				"bv::show::modal",
				"modal-assign-supplier-confirmation-view",
				event.target
			);
		},
		showCalculatePickupModal() {
			this.$root.$emit(
				"bv::show::modal",
				"calculate-massive-pickups",
				event.target
			);
		},
		toggleMassiveAssign() {
			if (!this.showSelectAll) {
				this.$refs.childtable.showMax();
			}
			this.showSelectAll = !this.showSelectAll;
		},
		exportXLS(withPrices, withFlightData = false) {
			this.exportLoading = true;
			api(this)
				.get(`/transport-services/export`, {
					params: {
						sortBy: this.sortBy,
						sortOrder: this.sortDesc ? "desc" : "asc",
						filters: this.filtersClean,
						withPrices: withPrices ? withPrices : null,
						withFlightData: withFlightData ? withFlightData : null
					},
					responseType: "blob"
				})
				.then(res => {
					let fileType = res.headers["content-type"]??'';
					let ext = (fileType.includes("text/csv"))?"csv":"xlsx";

					let blob = new Blob([res.data]);
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = url;
					a.download = "TransportServices."+ext;
					a.click();
					window.URL.revokeObjectURL(url);
					this.exportLoading = false;
				})
				.catch(error => {
					this.$root.handleRequestError(error);
					this.exportLoading = false;
				});
		},
		viewForm(item) {
			this.formTypeWork="viewForm";
			this.selected.tsSelectedId = item.id;
			this.selected.copyResId = -1;
			this.selected.modalModelId = item.reservationId;
			this.form.add = true
		},
		copyRes(resId) {
			this.formTypeWork="newFormCopy";
			this.selected.copyResId = resId;
			//se enviar -1 para determinar que es un nuevo registro
			this.selected.modalModelId = -1;
			this.form.add = true
		},
		newForm(){
			this.formTypeWork="newForm";
			this.SET_RESET_MODEL();
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
			this.form.add = true;


		},
		newFormQuote(){
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
			// let existCartAdditional=this.viewModel.additionalServices.find(item=>{return item.id==-1});
			let existCartTransport=this.viewModel.transportServices.find(item=>{return ("cartId" in item)});
			if(existCartTransport && this.viewModel.id == -1){
				console.log("");
			}else{
				//reseteamos el viewModel para crear uno nuevo
				this.SET_RESET_MODEL();
				// eliminaos todos los transport service
				this.DEL_TRANSPORT_SERVICE(0);
			}
			this.SET_UPDATE_QUOTE_PROPS({showForm:true})//?? en que momento se recupera la infrmacion consultada en el modal de cotizacion
			// abrimos el modal de cotizacion
			// this.formQuoteModal=true;
			// this.$refs['refFormQuoteV2'].show();
		},
		resetPropsReservations(){
			this.selected.tsSelectedId=-1
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
		},
		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.delete(`/reservations/${item.id}`)
						.then(() => {
							this.$root.showAlert("Registro Eliminado!", {
								variant: "warning"
							});
							this.$root.$emit(
								"bv::refresh::table",
								"reservations-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		changeFormTypeWork(estatus){
			this.$nextTick(()=>{
				this.formTypeWork=estatus;
			});
		},
		iconSupplierConfirmation(status) {
			let icon = "";
			let classe = "";
			switch (status) {
				case "pending":
					icon = "warning";
					classe = "text-warning";
					break;
				case "confirmed":
					icon = "check_circle";
					classe = "text-success";
					break;
				case "rejected":
					icon = "dangerous";
					classe = "text-danger";
					break;
			}
			return { icon: icon, class: classe };
		},
		additionalServiceString(item){
			let nodeAdditionalServicesByBooking = [...item.reservation.additionalServices]
			let nodeAdditionalServicesByTs      = [...item.additionalServices]
			nodeAdditionalServicesByBooking     = nodeAdditionalServicesByBooking.filter(e => !(e.transportServiceId>0))// quitamos los que estan ligados a un TS
			let listMerged = [...nodeAdditionalServicesByTs,...nodeAdditionalServicesByBooking]
			let str = listMerged.map(e => e.additionalServiceType.name).join(" | ");
			return str;
		},
		getTimeAgo(date){
			return moment(date).fromNow();
		},
		isFlightTag(tagId) {
			return this.flightTagIds.includes(tagId);
		},
		formatDateTime(date) {
			return moment(date).format("DD/MM/YYYY HH:mm");
		}
	},
	mounted() {
		let notificationDay = moment().format("YYYY-MM-DD");
		if (notificationDay != localStorage.getItem("last-notification-day")) {
			localStorage.setItem("last-notification-day", notificationDay);
			// this.launchNotifications(true);
		} else {
			// this.launchNotifications(false);
		}
		try{
			this.intervalVar  = setInterval(()=>{
			this.itemsTable.forEach((item)=>{
				item.timeAgoAssigned= this.getTimeAgo(item.supplierAssignedAt);//actualizamos el time ago
			})
		}, 600000); // Update every 10 minutes
		}catch(err){
			clearInterval(this.intervalVar);
		}
	},
	created() {},
	destroyed() {
		clearInterval(this.intervalVar);
	},
	watch: {}
};
</script>

<style>
.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}
.active-filter {
	border: 2px solid #021d3e;
}
.snotifyToast__title {
	font-size: 1.5em;
}
.inline-heading {
	display: inline;
}
.inline-button {
	margin-bottom: 10px;
}
.sc-purple {
	color: #4f39cf;
}
</style>
